// extracted by mini-css-extract-plugin
export default {"jrSkeleton":"util_jrSkeleton__zidMb","imgSkeleton":"util_imgSkeleton__Tnx7v","pSkeleton":"util_pSkeleton__cDK0T"};